module.exports = __webpack_public_path__ + "Roboto-Medium.1d2af757de4340d6b644.ttf";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Medium.ttf
// module id = ../../../../../src/assets/fonts/Roboto-Medium.ttf
// module chunks = styles